//#region import libraries
//react
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';


// nav
import { NavLink } from 'react-router-dom';

// bootstrap
import { Navbar, Button, Dropdown, DropdownButton } from 'react-bootstrap';

// images
import bgNo from "_assets/images/PRM-Logo-PNG/PRM-Assist-Logo-Col.png";
import textWhiteLogo from "_assets/images/logo/white-logo-text.png";

// styling
import './navbarnew.css';

//#endregion

const NavBarNew = (props) => {

    //#region state
    // FIXME: fix the ui when background is not a picture
    const [switchColor, setSwitchColor] = useState(false);
    const isPhone = useMediaQuery({ query: '(max-width: 1200px)' })
    const [isNavExpanded, setIsNavExpanded] = useState(false);

    //#endregion

    //#region side effects
    useEffect(() => {
        let { from } = props;
        if (from !== 'home') {
            setSwitchColor(true);
            return;
        }
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setSwitchColor(scrollTop > 30);
        };

        window.addEventListener('scroll', handleScroll);
        if (from !== 'home') {
            setSwitchColor(true);
        }

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (isNavExpanded) {
          document.body.style.overflowY = 'hidden';
        } else {
          document.body.style.overflowY = 'auto';
        }
      }, [isNavExpanded]);
      
    //#endregion

    return (
        <Navbar
            expand="lg"
            className={`main-navbar d-flex ${switchColor ? 'scrolled' : ''}`}
            sticky="top"
            expanded={isNavExpanded} 
            onToggle={() => setIsNavExpanded(prev => !prev)}
        >
            {/* Left: Logo Switcher */}
            <div className="d-flex logo-switcher">
                {/* Custom logo when not scrolled */}
                <div className={`custom-logo d-none d-lg-block ${switchColor ? 'hide' : ''}`}>
                    <div className="logo-wrapper">
                        <div className="side-bar top" />
                        <div className="logo-box">
                            <div className="logo-box-inner">
                                <img className='logo-img' src={textWhiteLogo} />
                                {/* <img className='logo-img' src={bgNo} /> */}
                            </div>
                        </div>
                        <div className="side-bar bottom" />
                    </div>
                </div>

                {/* Simple logo when scrolled */}
                <Navbar.Brand href="/" className={`d-none d-lg-block simple-logo p-3 ${switchColor ? 'show' : ''}`}>
                    <img className='logo-img-secondary' src={bgNo} />
                </Navbar.Brand>
            </div>

            {/* Mobile Logo */}
            <Navbar.Brand href="/" className="d-lg-none w-50 me-auto">
                <img className='logo-img-secondary-mobile p-3' src={`${switchColor ? bgNo : textWhiteLogo}`} />
            </Navbar.Brand>

            {/* Toggler */}
            <Navbar.Toggle aria-controls="navbar-nav" className='mx-2' />

            {/* Links */}
            <Navbar.Collapse id="navbar-nav">
                <div className="d-flex w-100 mt-5 mt-lg-0 full-vh flex-column align-items-center flex-lg-row p-3 px-lg-3 gap-3 justify-content-start justify-content-lg-end" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 'bold' }}>
                    {/* FIXME: uncomment later */}
                    {/* <NavLink to="/">
                        <Button variant="outline-none" className={`${!switchColor ? 'nav-btn-white' : 'nav-btn-dark'} nav-hover`}>Home</Button>
                    </NavLink>
                    <DropdownButton variant='outline-none' className={`${!switchColor ? 'nav-btn-white' : 'nav-btn-dark'} nav-hover`} id="dropdown-basic-button" title="Products">
                        <Dropdown.Item href="#/action-1">PRM Assist</Dropdown.Item>
                        <Dropdown.Item href="#/action-1">PRM Portal</Dropdown.Item>
                        <Dropdown.Item href="#/action-2">PRM Connect</Dropdown.Item>
                        <Dropdown.Item href="#/action-3">PRM Marketplace</Dropdown.Item>
                    </DropdownButton>
                    <NavLink to="/business">
                        <Button variant="outline-none" className={`${!switchColor ? 'nav-btn-white' : 'nav-btn-dark'} nav-hover`}>News</Button>
                    </NavLink>
                    <NavLink to="/business">
                        <Button variant="outline-none" className={`${!switchColor ? 'nav-btn-white' : 'nav-btn-dark'} nav-hover`}>Company</Button>
                    </NavLink>
                    <NavLink to="/about-us">
                        <Button variant="outline-none" className={`${!switchColor ? 'nav-btn-white' : 'nav-btn-dark'} nav-hover`}>About</Button>
                    </NavLink>
                    <NavLink to="/contact">
                        <Button variant="outline-none" className={`${!switchColor ? 'nav-btn-white' : 'nav-btn-dark'} nav-hover`}>Contact us</Button>
                    </NavLink> */}

                    <a href="mailto:demorequest@prmassist.com?subject=Demo%20Request">
                        <Button variant={`${switchColor ? 'outline-primary' : 'outline-light'}`} className={`${!switchColor ? 'shadow' : ''}`} style={{ width: 150, borderRadius: 50 }}>Request a Demo</Button>
                    </a>
                    <NavLink to="/login">
                        <Button variant={`${switchColor ? 'outline-primary' : 'outline-light'}`} className={`${!switchColor ? 'shadow' : ''}`} style={{ width: 150, borderRadius: 50 }}>PRM Portal</Button>
                    </NavLink>
                </div>
            </Navbar.Collapse>
        </Navbar>
    )
}

export default NavBarNew;